export default {
  product: {
    label_1: 'KeyPal',
    label_2: '助記詞密盒',
    label_3: '皮革保護套',
    label_4: '所有產品',
    label_5: 'KeyPal Card',
  },
  upgrade: {
    label_1: '升级',
  },
  // learn标题下面的描述我不知道是什么文案
  learn: {
    label_1: '錢包安全',
    desc_1: '',
    label_2: '資產知識',
    desc_2: '',
    label_3: 'KeyPal學院',
    desc_3: '',
    label_3_1: 'KeyPal Plus 使用說明',
    label_3_2: 'KeyPal Card 使用說明',
  },
  others: {
    label_1: '關於',
    label_2: '隱私協議',
    label_3: '使用條款',
  },
  support: {
    label_1: '幫助中心',
    label_2: '購買問答',
    label_3: '社區中心',
  },
};
